function FieldsListIcon({ color }: { color: string }) {
    const svgString = `<svg
    width="31"
    height="31"
    viewBox="0 0 16 16"
    version="1.1"
    id="svg1"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1">
      <rect
        style="fill:${color};stroke-width:1.3997"
        id="rect2"
        width="7.771728"
        height="7.0663309"
        x="8.5209465"
        y="9.2252893"
        ry="0.65545058"
        transform="matrix(1,0,-0.18836026,0.9821,0,0)"
      />
      <rect
        style="fill:${color};stroke-width:1.31101"
        id="rect2-6"
        width="7.6176047"
        height="6.3245993"
        x="8.7755394"
        y="2.125555"
        ry="0.58664989"
        transform="matrix(1,0,-0.20627713,0.97849361,0,0)"
      />
      <path
        id="rect3"
        style="fill:${color};stroke-width:1.48489"
        d="M 5.8949252,5.4062259 C 5.4014395,6.3179589 4.8255607,7.0217317 4.2542314,7.8954364 3.6371051,7.1537383 3.1130217,6.4258041 2.5274091,5.4140036 2.2834493,5.4949286 2.0659513,5.7422741 2.0029761,6.0370411 l -0.907426,4.2459869 c -0.077101,0.360893 0.1078626,0.653229 0.4134446,0.653229 h 3.630472 c 0.3056158,0 0.612647,-0.292336 0.6897489,-0.653229 L 6.7366405,6.0370411 C 6.8137436,5.6761466 6.630997,5.3726183 6.3257096,5.3865572 Z"
      />
      <rect
        style="fill:${color};stroke-width:1.52858"
        id="rect4"
        width="4.7709961"
        height="4.6087055"
        x="3.4160917"
        y="11.736412"
        ry="0.65857112"
        transform="matrix(1,0,-0.21677997,0.97622049,0,0)"
      />
      <path
        id="path13-5"
        style="fill:${color};fill-opacity:1;stroke-width:1.27131;stroke-dasharray:none;paint-order:fill markers stroke"
        d="M 4.3155465,3e-8 C 4.1134276,3e-8 3.9090269,0.02275823 3.7319887,0.06537453 3.3779142,0.15060725 3.1265182,0.32131854 2.9140715,0.55467458 2.7016274,0.78803157 2.5288069,1.0826184 2.4383198,1.3965874 c -0.090489,0.313969 -0.097009,0.6454717 -0.077341,1.0221813 0.019672,0.3767104 0.064864,0.8002337 0.1710828,1.2083932 0.1062238,0.4081595 0.2705464,0.8100893 0.4711891,1.200375 0.2006428,0.3902858 0.4366479,0.7767861 0.660896,1.1133064 0.224248,0.3365203 0.6683901,0.8796536 0.6683901,0.8796536 0,0 0.4212849,-0.5431347 0.6534025,-0.8796536 C 5.2180572,5.604323 5.4610075,5.2178227 5.6655854,4.8275369 5.8701633,4.4372512 6.0388401,4.0353214 6.1529318,3.6271619 6.2670235,3.2190024 6.3301237,2.7954801 6.3497947,2.4187687 6.3694666,2.0420581 6.3451895,1.7105575 6.2349575,1.3965874 6.1247994,1.0826184 5.9279589,0.78803157 5.7076436,0.55467458 5.4873307,0.32131854 5.2445561,0.15060543 4.894414,0.06537456 4.7193431,0.0227582 4.5176621,0 4.315544,0 Z M 4.3975795,1.2182975 C 4.9512851,1.218395 5.4002235,1.7299746 5.4006397,2.361318 5.4002245,2.9926624 4.9512844,3.5042429 4.3975776,3.5043395 3.8438708,3.5042419 3.3949315,2.9926616 3.3945153,2.361318 3.3949315,1.7299746 3.8438708,1.2183941 4.3975776,1.2182975 Z"
      />
    </g>
  </svg>`;

    return <div dangerouslySetInnerHTML={{ __html: svgString }} />;
}
export default FieldsListIcon;
